import React from "react";

const TabNav = ({ navItems, active, setActive }) => {
  return (
    <>
      <div className="tabs-nav bg-white flex items-center justify-between p-1">
        {navItems.map((item) => (
          <div
            className={`w-full text-md text-center p-3 capitalize cursor-pointer border-b-4 border-solid ease-in-out duration-300 ${
              active === item ? "border-brand" : ""
            }`}
            id={item}
            key={item}
            onClick={() => setActive(item)}
          >
            {item}
          </div>
        ))}
      </div>
    </>
  );
};

export default TabNav;
